/* Las puertas de la cuenta: lo que hay en el desplegable del nombre, y en el móvil, debajo.
 *
 * ESTÁN AQUÍ Y NO ESCRITAS DOS VECES EN LA BARRA, y es la razón de que existan como lista. Hasta
 * el 10 de octubre de 2026 solo estaban en el desplegable de pantalla ancha: **en el móvil no se
 * podía salir de la cuenta**, ni llegar a Ajustes, ni a los cofres, ni a los materiales (roadmap
 * móvil, 1.2). Copiarlas al panel del móvil habría sido dos listas que tienen que decir lo mismo
 * y nada que las obligue. Así las pintan los dos sitios del mismo sitio.
 *
 * LO QUE SE DECIDIÓ DE CADA UNA, que antes vivía en comentarios de la barra:
 *   · RECUERDOS NO ESTÁ: está en Herramientas, y dos puertas al mismo sitio en la misma barra no
 *     son el doble de fáciles de encontrar, son dos menús que hay que mirar enteros.
 *   · «ENTRAR EN UNA CLASE»: el QR sirve en septiembre, cuando el profesor lo proyecta; en
 *     octubre llega uno nuevo con el código apuntado y nadie proyecta nada.
 *   · «MIS ALUMNOS» solo para profesor y administración: un profesor que no fuera admin no tenía
 *     forma de llegar a su propio panel.
 *   · AJUSTES existía desde el 28 de agosto y no lo enlazaba nadie. Quien más lo necesita —más
 *     contraste, otra letra— es quien menos va a inventarse una dirección.
 */
export const ENLACES_DE_CUENTA = [
  { to: "/alpha", label: "Mi panel", testid: "nav-dashboard" },
  { to: "/personaje", label: "Crear tu Estrella Alpha", labelConAvatar: "Editar tu Estrella Alpha",
    testid: "nav-create-avatar", rojo: true },
  { to: "/cofres", label: "Cofres", testid: "nav-cofres" },
  { to: "/mis-materiales", label: "Mis materiales", testid: "nav-materiales" },
  { to: "/entrar", label: "Entrar en una clase", testid: "nav-entrar" },
  { to: "/profesor", label: "Mis alumnos", testid: "nav-profesor", roles: ["admin", "teacher"] },
  { to: "/ajustes", label: "Ajustes", testid: "nav-ajustes" },
];

/** Las que ve esta cuenta, con el rótulo que le toca. */
export function enlacesPara(user, conAvatar = false) {
  return ENLACES_DE_CUENTA
    .filter((e) => !e.roles || e.roles.includes(user?.role))
    .map((e) => ({ ...e, label: conAvatar && e.labelConAvatar ? e.labelConAvatar : e.label }));
}
